export const roundToInt = (num) => Math.round(num);
export const toInt = (value) => {
    return Number.parseInt(value);
};
export const isInt = (num) => num % 1 === 0;
